import React from 'react';

const ModeloDanfeContext = React.createContext();

export default ModeloDanfeContext;
